import React, { useState } from 'react';
import JobProfileInput from './input/JobProfileInput';
import SuperProfileInput from './input/SuperProfileInput';
import QualificationsAndRequirementsInput from './input/QualificationsAndRequirementsInput';
import SuperMatchBenchmarksInput from './input/SuperMatchBenchmarksInput';
import SuperProfileFormButtons from './input/SuperProfileFormButtons';
import { Form } from 'formik';
import UpdateSuperProfileConfirmationDialog from '../update/UpdateSuperProfileConfirmationDialog';

const SuperProfileForm = ({ jobProfiles, availableCountries, availableLanguages }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <UpdateSuperProfileConfirmationDialog visible={visible} hide={() => setVisible(false)} />
      <Form>
        <div className="p-grid">
          <div className="p-col-6">
            <JobProfileInput />
          </div>
          <div className="p-col-6">
            <SuperProfileInput jobProfiles={jobProfiles} />
            <br />
            <QualificationsAndRequirementsInput
              availableCountries={availableCountries}
              availableLanguages={availableLanguages}
            />
            <br />
            <SuperMatchBenchmarksInput />
          </div>
        </div>
        <SuperProfileFormButtons showUpdateConfirmationDialog={() => setVisible(true)} />
      </Form>
    </>
  );
};

export default SuperProfileForm;
